import * as React from "react";
import YouMayAlsoLikePlaceholder from "./YouMayAlsoLikePlaceholder";

function Placeholder(props: {
	numberOfLineItems: number;
}) {

	if(!props.numberOfLineItems) {
		return <div className="c-basket c-basket--placeholder-no-items"></div>;
	}

	return <div className="c-basket c-basket--placeholder">
		<div className="c-basket__main">
			{
				[...Array(props.numberOfLineItems)].map((element, index) => <div className="c-basket__item c-basket__item--placeholder" key={index}></div>)
			}
		</div>
		<div className="c-basket__sidebar">
			<div className="c-basket__sidebar-item c-basket__sidebar-item--placeholder"></div>
		</div>
		<YouMayAlsoLikePlaceholder />
	</div>
}

export default Placeholder;
